// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '6958ca6d40b583e936f950222292b50ab2a56964';
export const BUILD_NUMBER = '212';
export const BUILD_TIMESTAMP = '2026-07-29T10:09:33.530Z';
